// extracted by mini-css-extract-plugin
export default {"button":"ButtonClose_button__rU9Ny"};